import { render } from "./ServicesPage.vue?vue&type=template&id=40ef9b78&scoped=true"
const script = {}

import "./ServicesPage.vue?vue&type=style&index=0&id=40ef9b78&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.30_webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40ef9b78"]])

export default __exports__